export default "__VITE_ASSET__p$sPrQxC__"